import { Alert } from "../../../components/ui/Alert";
import { Card } from "../../../components/ui/Card";
import { CopyButton } from "../../../components/ui/CopyButton";
import { type IssuedBootstrapToken } from "../../../lib/api/bootstrap";
import { t } from "../../../lib/i18n";

import { QRCodeBox } from "./QRCodeBox";

interface BootstrapJustIssuedCardProps {
  issued: IssuedBootstrapToken;
}

/** Reusable bootstrap QR disclosure block for newly-created and stored codes. */
export function BootstrapJustIssuedCard({ issued }: BootstrapJustIssuedCardProps) {
  const payloadJson = JSON.stringify(issued.qr_payload, null, 2);

  return (
    <Card title={t("admin.bootstrap.qr.title")}>
      <Alert tone="info">{t("admin.bootstrap.qr.hint")}</Alert>

      <div
        style={{
          marginTop: 16,
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          gap: 24,
          alignItems: "start",
        }}
      >
        <QRCodeBox
          value={payloadJson}
          filename={`bootstrap-${issued.token.id.slice(0, 8)}`}
        />

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Field
            label={t("admin.bootstrap.justIssued.code")}
            value={issued.raw_code}
          />
          <Field
            label={t("admin.bootstrap.justIssued.payload")}
            value={payloadJson}
            multiline
          />
        </div>
      </div>
    </Card>
  );
}

interface FieldProps {
  label: string;
  value: string;
  multiline?: boolean;
}

function Field({ label, value, multiline }: FieldProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
        }}
      >
        <span style={{ fontSize: 12, color: "var(--text-muted, #666)" }}>{label}</span>
        <CopyButton value={value} />
      </div>
      <code
        className="code-block"
        style={{
          background: "var(--surface-2, #f6f6f6)",
          border: "1px solid var(--border, #e2e2e2)",
          borderRadius: 6,
          padding: "8px 10px",
          fontSize: 12,
          whiteSpace: multiline ? "pre" : "nowrap",
          overflowX: "auto",
          display: "block",
        }}
      >
        {value}
      </code>
    </div>
  );
}
